module.exports = __webpack_public_path__ + "static/jeff-sippel.e07416fc.webp";